<template>
    <div class="printOrderListBox">
        <el-tabs v-model="activeName" class="orderListTabs" @tab-click="searchInfo">
            <el-tab-pane v-for="item in tabList" :key="item.id" :label="item.name" :name="item.id">
            </el-tab-pane>
        </el-tabs>
        <div>
            <div class="orderSearchBox">
                <!-- <el-date-picker
                    v-model="createDate"
                    type="date"
                    placeholder="区间筛选">
                </el-date-picker> -->
            <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                     <el-date-picker
                        v-model="createDateValue"
                        @change="chooseDate"
                        type="daterange"
                         value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        >
                    </el-date-picker>
                </div>
                <el-input v-model="demandName" placeholder="需求名称"></el-input>
                <el-input v-model="demandPerson" placeholder="需求方"></el-input>
                <el-select v-model="evaluateStatus" placeholder="评价状态">
                    <el-option
                        label="好评"
                        value="好评">
                    </el-option>
                    <el-option
                        label="中评"
                        value="中评">
                    </el-option>
                    <el-option
                        label="差评"
                        value="差评">
                    </el-option>
                </el-select>
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="clearSearch">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">需求内容</li>
                    <li class="price">预算</li>
                    <li class="time">报价截止日期</li>
                    <li class="offer">报价</li>
                    <li class="expect">预计交付</li>
                    <li class="status">订单状态</li>
                    <li class="status">操作</li>
                </ul>
                <ul class="tableBody" v-if="tableForm.length != 0" v-loading="loading">
                    <li
                        class="bodyItem"
                        v-for="(designItems, designIndex) in tableForm"
                        :key="designIndex"
                    >
                        <div class="itemTop">
                            <div>创建时间：{{ designItems.orderBase.createDate }}</div>
                            <div>需求方：{{ designItems.orderBase.creatorName }}</div>
                            <i class="iconfont icon-weixin" @click="startChat(designItems.orderBase.creatorUuid)"></i>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div class="orderInfo">
                                    <div class="infoContent">
                                        <div class="infoName">{{ designItems.demandName }}</div>
                                        <div class="infoOther">
                                            {{ designItems.demandRemark }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="price">￥{{ designItems.lowPreAmount }}-{{ designItems.highPreAmount }}</div>
                            <div class="time">{{ designItems.deadLine }}</div>
                            <div class="offer">{{ designItems.offerPrice }}</div>
                            <div class="expect">{{ designItems.planDeliveryTime }}</div>
                            <div class="status">
                                {{ designItems.designStatusCn }}
                                <el-button type="text" class="operationBtn" @click="designOrderDetail(designItems)">订单详情</el-button>
                            </div>
                            <div class="operation">
                                <!--<el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='OFFLINE_UN_CONFIRM'" @click="onClickEvidence(designItems)">确认线下支付</el-button>-->
                                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_DESIGN' && JSON.stringify(designItems.modelList)!='[]'" @click="uploadDesignFiles(designItems)">重新上传</el-button>
                                <el-button type="text" class="operationUploadBtn" v-if="designItems.designStatus==='UN_DESIGN' && JSON.stringify(designItems.modelList)=='[]'" @click="uploadDesignFiles(designItems)">上传设计文件</el-button>
                                <!-- <el-button type="text" class="operationUploadBtn"  @click="uploadDesignFiles(designItems)">上传设计文件</el-button> -->
                            </div>
                        </div>
                    </li>
                </ul>
                <!-- <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div> -->
                <div class="orderNomesaage" v-loading="loading" v-else >
                    <img src="../../../assets/images/暂无订单.jpg" alt="" style="width:200px">
                </div>
            </div>
            <el-pagination
                v-if="tableForm.length != 0"
                background
                @current-change="handleCurrentChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                layout="total,prev, pager, next,jumper"
                :page-size="pageSize"
                :total="total" class="pagination">
            </el-pagination>
        </div>
        <!--上传设计文件-->
        <upload-design-files ref="uploadDesignFilesRef" @submit="uploadDesignFilesSubmit"></upload-design-files>

        <!--聊天窗口-->
        <chat-dialog ref="chatDialogRef"></chat-dialog>

        <!-- 打款凭证 -->
        <evidence-mess ref="evidenceRef"  @offlinePay="offlinePayOrder"></evidence-mess>
    </div>
</template>

<script>
import {getDesignOrderList, getRongCloudUser, updateDesignOrderStatus, findUpdateList,offlinePayConfirm} from '../../../utils/interface';
import uploadDesignFiles from './uploadDesignFiles'
import chatDialog from "../../../components/chat/chatDialog";
import evidenceMess from "../../../components/evidence/evidence";
export default {
    data() {
        return {
            activeName: '0',
            tabList: [
                {
                    id: '',
                    name: '全部'
                },
                {
                    id: 'UN_PAY',
                    name: '待付款'
                },
                {
                    id: "PLATFORM_ADVANCES_UN_CONFIRM",
                    name: "先行支付确认中",
                },
                {
                    id: 'UN_DESIGN',
                    name: '设计中'
                },
                {
                    id: 'UN_CONFIRM',
                    name: '设计待确认'
                },
                {
                    id: 'UN_APPRAISE',
                    name: '待评价'
                }
            ],
            createDate: '',
            createDateValue:null,
            startTime:"",
            endTime:"",
            demandName: '',
            designerName: '',
            demandPerson: '',
            transactionStatus: '',
            evaluateStatus: '',
            tableForm:[],
            loading: true,
            pageNo: 1,
            total: 0,
            pageSize: 8,
            order:{},
        }
    },
    components: {
        uploadDesignFiles,
        chatDialog,
        evidenceMess
    },
    created(){
        this.getList();
    },
    methods: {
        clearSearch(){
            this.modelNameValue = '';
            this.merchantNameValue = '';
            this.orderNumberValue = '';
            this.transactionStatus = '';
            this.createDateValue = null;
            this.startTime = "",
            this.endTime = "",
            this.demandPerson = '';
            this.searchInfo();
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
        searchInfo(){
            this.pageNo = 1;
            this.getList();
        },
        getList(){
            this.loading = true
            let params = {
                orderNo:this.orderNumberValue,
                demandName:this.demandName,
                designerName:this.merchantNameValue,
                startDate:this.startTime,
                endDate:this.endTime,
                //createDate:this.createDateValue==null?null : this.createDateValue.getFullYear() +'-'+ (this.createDateValue.getMonth() + 1) +'-'+this.createDateValue.getDate(),
                orderStatus:this.activeName=='0'?'':this.activeName,
                demandPerson:this.demandPerson,
                isBuy:false,
                current:this.pageNo,
                pageSize:this.pageSize
            };
            getDesignOrderList(params).then((res)=>{
                this.tableForm = res.data;
                if(this.tableForm.length){
                    // 查询是否已经提交过意见了
                    this.tableForm.map(item=>{
                        findUpdateList({isUpdate:1,demandUuid:item.demandUuid}).then((res)=>{
                            if(res.success){
                                this.$set(item, "modelList", res.data);
                                //item.modelList = res.data;
                            }
                        });
                    });
                }
                this.total = res.total;
                this.loading = false
            });
        },
        // 分页
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getList();
        },
        // 同意/拒绝退款
        refund(val){
            if(val){
                this.$confirm('确定要同意退款吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '退款成功!'
                    });
                }).catch(() => {})
            } else {
                this.$prompt('请输入拒绝理由：', '拒绝退款', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    this.$message({
                        type: 'success',
                        message: '提交成功！'
                    });
                }).catch(() => {})
            }
        },
        // 上传设计文件
        uploadDesignFiles(item){
            // 打开上传设计文件弹出框
            this.$refs.uploadDesignFilesRef.init(true,item);
            /*updateDesignOrderStatus({uuid:item.uuid,status:"UN_CONFIRM"}).then((res)=>{
                if(res.success){
                    this.$message.success('需求设计提交成功！');
                    this.getList();
                }
            });*/
        },
        // 获取上传成功后的设计文件列表
        uploadDesignFilesSubmit(val){
            this.getList();
            /*this.$message({
                type: 'success',
                message: '保存成功！'
            });
            // 关闭上传设计文件弹出框
            this.$refs.uploadDesignFilesRef.init(false)*/
        },
        // 设计订单详情
        designOrderDetail(item){
            this.$router.push({name:'designOrderDetail',params:{uuid:item.uuid}});
        },
        startChat(targetUuid) {
            let user = this.$store.state.userMessages;
            getRongCloudUser(targetUuid).then(res=> {
                console.log(res);
                this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
            });
        },
        onClickEvidence(item){
            this.order = item;
            this.$refs.evidenceRef.init(item)
        },
        offlinePayOrder(){
            this.$confirm('确定已收到货款吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                offlinePayConfirm(this.order.orderBase.orderNo).then(res=> {
                    if (res && res.success) {
                        this.$message.success(res.message);
                        this.getList();
                    }else {
                        this.$message.error(res.message);
                    }
                    this.order = {};
                    this.$refs.evidenceRef.close();
                });
            }).catch(() => {
            })

        },
    }
}
</script>

<style scoped lang="less">
    .printOrderListBox {
        padding: 94px 20px 20px;
        .orderListTabs{
            position: absolute;
            left: 0;
            top: 0;
            z-index: 999;
            background: #fff;
            width: 100%;
            padding: 20px;
        }
        /deep/ .el-tabs__item {
            padding: 0 25px !important;
            text-align: center;

            &:hover {
                color: #3686d7
            }

            &:after {
                content: "";
                position: absolute;
                right: 0;
                bottom: 12px;
                width: 1px;
                height: 15px;
                background-color: #E4E7ED;
                z-index: 1;
            }

            &:last-child:after {
                content: "";
                width: 0;
                height: 0;
            }
        }

        /deep/ .el-tabs__active-bar {
            height: 3px;
            background-color: #3686d7;
        }

        /deep/ .el-tabs__item.is-active {
            color: #3686d7
        }

        /deep/ .el-tabs__nav-wrap::after {
            height: 1px;
        }

        .orderSearchBox {
            display: flex;
            flex-wrap: wrap;
.timeSearch{
                background-color:#f2f4f7;
                height: 35px;
                display: flex;
                align-items: center;
                margin-bottom: 22px;
                margin-right: 30px;
                border-radius: 8px;
                span{
                    font-size: 12px;
                    color: #c0c4cc!important;
                    font-weight: normal;
                    padding-left: 15px;
                    margin-right: 5px;
                }
                // /deep/ .el-range-input{
                //         background-color: #f2f4f7;
                //             &:hover, &:focus {
                //             background-color: #fff;
                //             // border: 1px solid #108EE9;
                //         }
                // }
                /deep/input::-webkit-input-placeholder {
                    color: #c0c4cc;
                    font-size: 12px;
                }
              /deep/.el-range-input:hover{
                  background-color: #fff!important;
              }
              /deep/ .el-date-editor .el-range-separator{
                  line-height: 25px;
                  color: #c0c4cc;
              }
             /deep/ .el-date-editor .el-range__close-icon{
                 line-height: 28px;
             }
              /deep/ .el-input__inner:hover  .el-range-input, /deep/ .el-input__inner:focus  .el-range-input{
                  background-color: white;
              }
                /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;
                .el-range-input{
                    background-color:#f2f4f7 ;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
            /deep/ .el-icon-date:before {
                    content: "\E78E";
                    display: none;
                }
                /deep/.el-input__icon{
                    // display: none;
                }
            }
            /deep/ .el-input {
                width: initial;
                margin-bottom: 22px;
                margin-right: 30px;
            }
 /deep/.el-input__suffix-inner .el-icon-circle-close{
                line-height: 32px;
            }
            /deep/ .el-input__inner {
                width: 242px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;
                }
            }

            /deep/ .el-input__prefix {
                top: -3px;
            }

            /deep/ .el-input__suffix {
                top: 2px;
            }

            /deep/ .el-button {
                display: block;
                line-height: 35px;
                padding: 0;
                height: 35px;
            }

            .searchBtn {
                width: 82px;
                background: #3d7fff;
                border: none;
                border-radius: 15px;
                font-size: 14px;
                color: #FFFFFF;
                margin-bottom:22px;
            }

            .resetBtn {
                color: #333333;
                margin-bottom:22px;
            }
        }

        .orderListTable {
            min-width: 1400px;
            .orderNomesaage {
                color: #888;
                text-align: center;
                padding: 15px 0;
            }
            .tableHeader {
                display: flex;
                width: 100%;
                height: 35px;
                line-height: 35px;
                background: #f3f7ff;
                border-radius: 5px;
                margin: 0 0 15px;
                li {
                    text-align: center;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.85);
                }
            }

            .tableBody {
                li {
                    width: 100%;
                    border: 1px solid #f2f2f2;
                    border-radius: 10px;
                    margin-bottom: 15px;
                    .itemTop {
                        width: 100%;
                        height: 42px;
                        background: #ebf3fb;
                        line-height: 42px;
                        font-size: 14px;
                        color: #333;
                        padding: 0 20px;
                        display: flex;
                        align-items: center;
                        position: relative;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            margin-left: -25px;
                            display: block;
                        }

                        div {
                            margin-right: 30px;
                        }

                        .merchantInfo {
                            display: flex;
                            align-items: center;

                            i {
                                color: #3d7fff;
                                font-size: 25px;
                                cursor: pointer;
                                padding-left: 10px;
                                display: block;
                            }

                            img {
                                width: 24px;
                                height: 24px;
                                border-radius: 50%;
                                display: block;
                                margin-right: 10px;
                            }
                        }

                        .complainBtn {
                            color: #999;
                            position: absolute;
                            right: 20px;
                        }
                    }

                    .itemBottom {
                        display: flex;
                        align-items: center;
                        color: #333;
                        font-size: 13px;

                        .orderInfo {
                            padding: 20px;
                            .orderInfoName{
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                            }
                            .infoContent {
                                font-size: 13px;
                                color: #999999;
                                line-height: 22px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                            }
                        }

                        .arguments {
                            text-align: center;
                        }
                        .payment {
                            h3 {
                                font-size: 14px;
                                font-weight: 700;
                                margin: 0;
                            }

                            .title {
                                font-size: 12px;
                                color: #999999;
                            }
                        }
                        .status{
                            font-size: 14px;
                        }
                        .operation{
                            padding: 20px 0 10px;
                        }
                        .operationBtn{
                            display: block;
                            color: #0C75D3;
                            text-align: center;
                            width: 100%;
                            margin: 0;
                        }
                    }
                }
            }

            .name {
                flex: 1;
            }

            .price {
                width: 120px;
                text-align: center;
            }
            .time {
                width: 120px;
                text-align: center;
            }
            .num {
                width: 95px;
                text-align: center;
            }
            .designer {
                width: 95px;
                text-align: center;
            }
            .arguments {
                width: 294px;
            }

            .offer {
                width: 162px;
                text-align: center;
            }
            .expect {
                width: 162px;
                text-align: center;
            }
            .status {
                width: 124px;
                text-align: center;
            }
            .operation {
                width: 124px;
                text-align: center;
                .operationUploadBtn{
                    width: 102px !important;
                    height: 34px;
                    padding: 0;
                    line-height: 34px;
                    text-align: center;
                    font-weight: 700;
                    color: rgba(0, 102, 204, 0.8);
                    font-size: 14px;
                    border-color: rgba(0, 102, 204, 0.8);
                    display: block;
                    margin: 0 auto 10px !important;
                }
            }
        }
        .pagination {
            margin-top: 20px;
            text-align: right;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/transaction/orderManagement/designOrderList.vue